import { Observable } from 'rxjs';

import { Section } from 'phase/section/section';

export abstract class SectionRepositoryPort {
	public abstract observeSectionByPhaseId(
		phaseId: string
	): Observable<Section[]>;

	public abstract saveSections(sections: Section[]): Promise<void>;

	public abstract observeSection(sectionId: string): Observable<Section>;
}
